import BaseDataService from "./BaseDataService";

class PricingDataService extends BaseDataService {
  constructor(name) {
    super(name)
    this.moduleName = 'pricings'
  }

  search(payload) {
    return this.http.get(`/${this.moduleName}`, { params: payload });
  }
}

export default new PricingDataService();